export const unwrapResponse = (response) => {
  if (response && typeof response === 'object' && 'data' in response) {
    return response.data;
  }
  return response;
};

export const ensureArray = (payload) => {
  if (Array.isArray(payload)) {
    return payload;
  }
  if (payload && typeof payload === 'object' && 'data' in payload) {
    return ensureArray(payload.data);
  }
  return [];
};

export const extractArray = (response) => {
  const payload = unwrapResponse(response);
  return ensureArray(payload);
};

export const extractDataObject = (response) => {
  const payload = unwrapResponse(response);
  if (payload && typeof payload === 'object' && 'data' in payload && !Array.isArray(payload.data)) {
    return payload.data;
  }
  return payload;
};

